import enhancer from './enhancers'

import _LinkButton from './LinkButton'
import _Button from './Button'
export { PrimaryButton, SecondaryButton } from './SimpleButton'

export const LinkButton = enhancer(_LinkButton)
export const Button = enhancer(_Button)

Button.displayName = 'EnhancedButton'

export default Button
